import { useQuery, UseQueryResult } from '@tanstack/react-query'

export const getGeolocationKey = () => ['getGeolocation']

export function useGetGeolocation(): UseQueryResult<{
  lat: number
  lng: number
}> {
  return useQuery({
    queryKey: getGeolocationKey(),
    queryFn: () =>
      Promise.resolve({
        lat: 0,
        lng: 0
      })
  })
}
